import type { TransactionActionCapabilityDefinition } from '../../capabilities';
import { transactionActionExecutionProfiles } from '../../executionProfiles';
import type { CleanupTransactionEligibleTransaction } from './types';
import { parseCleanupTransactionAssistantResponse } from './validators';

// Capability definition (plugin-contract step 1 in docs/features/transaction-actions/README.md):
// registers cleanup_transaction's runner id, execution profile, and structured-response parser
// with the framework's capability registry (see ../../capabilities.ts).
export const cleanupTransactionActionCapability: TransactionActionCapabilityDefinition = {
  capability: 'cleanup_transaction',
  supportedInPhase1: true,
  executionProfile: transactionActionExecutionProfiles.cleanup_transaction,
  runnerId: 'structured_model',
  // The framework's parseStructuredResponse contract takes the base
  // TransactionActionEligibleTransaction[], but this capability's own eligible-transaction
  // snapshot is a superset (see types.ts). The cast is safe because the framework only ever
  // calls this with cleanup_transaction's own batch.eligibleTransactions.
  parseStructuredResponse: (eligibleTransactions, assistantResponse) =>
    parseCleanupTransactionAssistantResponse(
      eligibleTransactions as CleanupTransactionEligibleTransaction[],
      assistantResponse,
    ),
};
